import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import UserProfileToggle from './user_profile_toggle';
import PropTypes from 'prop-types';

export default function Organization({
  allBrokerOrganizations,
  pcUser = false,
  showOrganizationsOnBrokerPlugin,
  userOrganizations
}) {
  const [organizationsOnBrokerPlugin, setOrganizationsOnBrokerPlugin] = useState(showOrganizationsOnBrokerPlugin);

  const [selectedOrganizations, setSelectedOrganizations] = useState(
    userOrganizations.map(u => u.brokerOrganizationId)
  );

  function changeSelectedOrganizations(selectedOptions) {
    setSelectedOrganizations(selectedOptions.map(option => option.value));
  }

  const pcUserPrefix = pcUser ? 'parent_company_' : '';
  const organizationsBaseName = `${pcUserPrefix}user[${pcUserPrefix}user_broker_organizations_attributes]`;
  const persistedOrganizationIds = userOrganizations.map(c => c.brokerOrganizationId);
  const newOrganizationIds = selectedOrganizations.filter(c => !persistedOrganizationIds.includes(c));

  return (
    <React.Fragment>
      <h2 className="top-buffer-lg">Organizations</h2>
      <Row className="form-group">
        <Col md={6}>
          <Select
            classNamePrefix="react-select-buildout"
            isMulti
            options={allBrokerOrganizations}
            value={allBrokerOrganizations.filter(c => selectedOrganizations.includes(c.value))}
            onChange={selectedOptions => changeSelectedOrganizations(selectedOptions)}
          />
        </Col>
      </Row>

      {userOrganizations.map((userOrganization, index) => (
        <React.Fragment key={userOrganization.id}>
          <input name={`${organizationsBaseName}[${index}][id]`} type="hidden" value={userOrganization.id}/>
          <input
            name={`${organizationsBaseName}[${index}][broker_organization_id]`}
            type="hidden"
            value={userOrganization.brokerOrganizationId}
          />
          <input
            name={`${organizationsBaseName}[${index}][_destroy]`}
            type="hidden"
            value={!selectedOrganizations.includes(userOrganization.brokerOrganizationId)}
          />
        </React.Fragment>
      ))}

      {newOrganizationIds.map((organizationId, i) => {
        const index = i + userOrganizations.length;
        return (
          <input
            key={organizationId}
            name={`${organizationsBaseName}[${index}][broker_organization_id]`}
            type="hidden"
            value={organizationId}
          />
        );
      })}

      {!pcUser &&
        <UserProfileToggle
          checked={organizationsOnBrokerPlugin}
          label="Show on Broker Plugin"
          name="user[show_organizations_on_broker_plugin]"
          onChange={() => setOrganizationsOnBrokerPlugin(!organizationsOnBrokerPlugin)}
        />
      }
    </React.Fragment>
  );
}

export const organizationPropTypes = {
  allBrokerOrganizations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string
  })).isRequired,
  pcUser: PropTypes.bool,
  showOrganizationsOnBrokerPlugin: PropTypes.bool,
  userOrganizations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    brokerOrganizationId: PropTypes.number
  })).isRequired,
};

Organization.propTypes = organizationPropTypes;
